import moment from 'moment';
import { Observable, Subject } from 'rxjs';

import { FileType } from '../../../models/classes/files/FileType.enum';
import { FileService } from '../file.service';
import { FileContainerBase } from './FileContainer';
import { FileState } from './FileState.enum';
import { LoadingState } from './LoadingState.enum';
import { __ } from '../../../functions/object.functions';

export abstract class FileBase {
  id: string;

  parent: FileContainerBase;

  description: string = '';

  loadingState: LoadingState = LoadingState.Initial;

  kind: string;

  abstract state: FileState;

  abstract fileType: FileType;

  name: string;

  extension: string;

  size: number;

  mimeType: string;

  date: string;

  private _source: any;
  private _source$: Subject<any> = new Subject<any>();
  source$: Observable<any> = this._source$.asObservable();

  get source(): string | ArrayBuffer {
    return this._source;
  }
  set source(source: string | ArrayBuffer) {
    this._source = source;
    this._source$.next(source);
  }

  private _loadingProgress: number;
  private _loadingProgress$: Subject<number> = new Subject<number>();
  loadingProgress$: Observable<number> = this._loadingProgress$.asObservable();
  get loadingProgress(): number {
    return this._loadingProgress;
  }
  set loadingProgress(progress: number) {
    if (progress > 100) {
      progress = 100;
    }
    this._loadingProgress = progress;
    this._loadingProgress$.next(progress);

    if (!__.IsNullOrUndefined(this.parent)) {
      this.parent.setLoadingProgressForFile(this, progress);
    }
  }

  private _dataUrl: string;
  private _dataUrl$: Subject<string> = new Subject<string>();
  dataUrl$: Observable<number> = this._loadingProgress$.asObservable();
  get dataUrl(): string {
    return this._dataUrl;
  }
  set dataUrl(dataUrl: string) {
    this._dataUrl = dataUrl;
    this._dataUrl$.next(dataUrl);
  }

  constructor() {
    this.date = moment()
      .utc()
      .toISOString();
  }
}

export abstract class NewFileBase extends FileBase {

  abstract state: FileState;

  abstract fileType: FileType;

}

export abstract class ExistingFileBase extends FileBase {

}

export class NewFile extends NewFileBase {
  state = FileState.New;

  fileType = FileType.Video;

  constructor(public file: File) {
    super();

    this.name = file.name;
    this.mimeType = FileService.getMimeTypeByFileName(file.name);
    this.size = file.size;
    this.id = FileService.NewGuid();
  }
}

export class ExistingFile extends ExistingFileBase {
  state = FileState.Existing;

  fileType = FileType.Video;

  extension: string;

  constructor(url: string, extension: string) {
    super();

    this.dataUrl = url;
    this.extension = extension;
  }
}

export class NewImage extends NewFileBase {
  state = FileState.New;

  fileType = FileType.Image;

  constructor(public file: File) {
    super();

    this.name = file.name;
    this.mimeType = FileService.getMimeTypeByFileName(file.name);
    this.size = file.size;
    this.id = FileService.NewGuid();
    // this.dataUrl = file;
  }
}

export class ExistingImage extends ExistingFileBase {
  state = FileState.Existing;

  fileType = FileType.Image;

  constructor(url: string, extension: string) {
    super();

    this.dataUrl = url;
    this.extension = extension;
  }
}
